import { GET_SEASON, GET_ERROR, GET_SEASON_SUCCESS } from "./actionTypes"

export const getSeason = (data, isList) => ({
  type: GET_SEASON,
  payload: data,
  isList: isList,
})

export const getSeasonSuccess = data => ({
  type: GET_SEASON_SUCCESS,
  payload: data,
})

export const getSeasonError = data => ({
  type: GET_ERROR,
  payload: data,
})
